module.exports = __webpack_public_path__ + "img/CTWP__Shield_01.6a51e718.png";